import { getWindow } from '@shared/services/window';
import { Constants } from '@shared/utils/constants';
/**
 * log telemetry
 *
 * @param action action on nomination form
 * @param actionModifier action modifier on nomintaion form
 * @param details action details on nomintation form
 */ export const logTelemetry = (action, actionModifier, details = undefined, isFeedback = false)=>{
    const pageUrl = getWindow() && getWindow().location && getWindow().location.href || Constants.TypeOf.undefinedName;
    const payload = {
        page: pageUrl,
        action,
        actionModifier,
        isFeedback,
        details
    };
};
